<template>
    <v-layout>
        <v-dialog v-model="dialog" eager max-width="600px">
            <template v-slot:activator="{ on }">
                <v-fab-transition>
                    <v-btn v-on="on" :class="{ 'rounded-btn': true, w100: $vuetify.breakpoint.xsOnly }" outlined color="info">{{ $t('Сменить пароль') }}</v-btn>
                </v-fab-transition>
            </template>

            <LabeledCard :label="$t('Сменить пароль')">
                <v-container class="px-container pt-10" id="chpwd">
                    <v-form ref="changePassForm">
                        <v-row no-gutters>
                            <v-col cols="12" sm="12">
                                <v-text-field
                                    outlined
                                    prepend-inner-icon="account_circle"
                                    :append-icon="showPassword ? 'visibility' : 'visibility_off'"
                                    :type="showPassword ? 'text' : 'password'"
                                    @click:append="showPassword = !showPassword"
                                    v-model="oldPassword"
                                    :label="$t('Введите старый пароль')"
                                    validate-on-blur
                                    :rules="PasswordRequired"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row no-gutters>
                            <v-col cols="12" sm="12">
                                <v-text-field
                                    outlined
                                    prepend-inner-icon="account_circle"
                                    :append-icon="showPassword ? 'visibility' : 'visibility_off'"
                                    :type="showPassword ? 'text' : 'password'"
                                    @click:append="showPassword = !showPassword"
                                    v-model="newPassword"
                                    :rules="passwordRequirments"
                                    :label="$t('Введите новый пароль')"
                                    validate-on-blur
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row no-gutters>
                            <v-col cols="12" sm="12">
                                <v-text-field
                                    outlined
                                    prepend-inner-icon="account_circle"
                                    :append-icon="showPassword ? 'visibility' : 'visibility_off'"
                                    :type="showPassword ? 'text' : 'password'"
                                    @click:append="showPassword = !showPassword"
                                    v-model="newPasswordRetry"
                                    :rules="passwordConfirmationRule"
                                    :label="$t('Введите новый пароль еще раз')"
                                    validate-on-blur
                                ></v-text-field>
                            </v-col>
                        </v-row>
                    </v-form>

                    <v-row no-gutters>
                        <v-col cols="12" sm="5" class="d-flex justify-end"></v-col>
                        <v-col cols="12" sm="3">
                            <v-btn color="info" :class="{ 'rounded-btn': true }" outlined @click="dialog = false" style="width: 100%;">{{
                                $t('Отмена')
                            }}</v-btn>
                        </v-col>
                        <v-col cols="12" sm="1"></v-col>
                        <v-col cols="12" sm="3" :class="{ 'd-flex justify-end': true, 'pt-5': $vuetify.breakpoint.xsOnly }">
                            <v-btn color="info" :class="{ 'rounded-btn': true }" style="width: 100%;" @click="onclickSavePassword">
                                <span>{{ $t('Сохранить') }}</span>
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-container>
            </LabeledCard>
        </v-dialog>
    </v-layout>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import LabeledCard from '../ui/LabeledCard';
export default {
    components: {
        LabeledCard
    },
    data: () => ({
        dialog: false,
        passIncorrect: false,
        oldPassword: null,
        newPassword: null,
        newPasswordRetry: null,
        showPassword: false
    }),
    watch: {
        async dialog() {
            this.message = null;
            this.passIncorrect = false;
            this.oldPassword = null;
            this.newPassword = null;
            this.newPasswordRetry = null;
            this.$refs.changePassForm.resetValidation();
        }
    },
    methods: {
        ...mapActions('auth', ['changePassword']),
        async onclickSavePassword() {
            if (!this.$refs.changePassForm.validate()) return;
            let result = await this.changePassword({ passwordOld: this.oldPassword, passwordNew: this.newPassword });
            //

            switch (result.message) {
                case 'incorrectPassword':
                    this.passIncorrect = true;
                    this.$refs.changePassForm.validate();
                    this.passIncorrect = false;
                    break;
                case 'PasswordSuccessfullyChanged':
                    this.showMessAndClose();
                    break;
                default:
                    break;
            }
        },
        showMessAndClose() {
            this.dialog = false;
            let color = 'success';
            let message = 'Новый пароль успешно сохранен';
            this.$store.dispatch('base/showMessage', { color, message });
        }
    },
    computed: {
        ...mapState('users', ['userInfo']),
        PasswordRequired: function(v) {
            return [
                v => (v && v !== null) || this.$t('Обязательное поле'),
                v => !this.passIncorrect || this.$t('Прежний пароль введён неправильно. Если Вы забыли его, то воспользуйтесь системой восстановления пароля')
            ];
        },
        passwordConfirmationRule: function(v) {
            return [
                v => (v && v !== null) || this.$t('Обязательное поле'),
                this.newPassword === this.newPasswordRetry || this.$t('Введенные значения новых паролей не совпадают')
            ];
        },
        passwordRequirments: function(v) {
            return [
                v => (v && v !== null) || this.$t('Обязательное поле'),
                v => (v && v !== null && v.length >= 10) || this.$t('Длина пароля должна быть не менее 10 символов'),
                v =>
                    /^(^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!~^%*)_+(#}{|'";:/.,><?&])[A-Za-z\d@$!~^)_+(%*#}{|'";:/.,><?&]{10,}$)$/.test(v) ||
                    this.$t('В числе символов пароля обязательно должны присутствовать буквы, цифры и специальные символы (@, #, $, &, *, % и т.п.)'),
                v => v !== this.oldPassword || this.$t('При смене пароля новый пароль должен отличаться от старого не менее, чем на один символ')
            ];
        }
    },
    async mounted() {}
};
</script>
